<template>
    <div id="valuation-start">
        <div class="loader" v-if="loadingValuationData === true">
            <LoadingSpinner/>
        </div>
        <div v-else>
            <FindMyCar v-if="step === 1" />
            <ConfirmYourCar v-else-if="step === 2" />
            <YourSummary v-else-if="step === 3" />
            <YourValuation v-else-if="step === 4" :show-extended-valuation="showExtendedValuation" />
            <ManualValuationConfirmation v-else-if="step === 5" />
            <VehicleCondition v-else-if="step === 6" />
            <ServiceHistory v-else-if="step === 7" />
            <MechanicalCondition v-else-if="step === 8" />
            <VehicleWalkaround v-else-if="step === 9" />
            <YourValuation v-else-if="step === 10" />
        </div>
        <create-account-modal v-if="loginModal.show"></create-account-modal>
    </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { FindMyCar, ConfirmYourCar, YourSummary, YourValuation, ManualValuationConfirmation, VehicleCondition, ServiceHistory,  MechanicalCondition, VehicleWalkaround, CreateAccountModal} from "./components/index";
import LoadingSpinner from "../core/components/LoadingSpinner.vue";

export default {
    components: {
        FindMyCar,
        ConfirmYourCar,
        YourSummary,
        YourValuation,
        ManualValuationConfirmation,
        VehicleCondition,
        ServiceHistory,
        MechanicalCondition,
        VehicleWalkaround,
        CreateAccountModal,
        LoadingSpinner,
    },

    props: {
        heading: {
            required: false,
            type: String,
        },
        // Internal ID of the location if set
        useSpecificDealer: {
            required: false,
        },
        // used vehicle ID of interest (optional)
        usedVehicleId: {
            required: false,
        },
        // new vehicle ID of interest (optional)
        newVehicleId: {
            required: false,
        },
        // new model ID of interest (optional)
        newModelId: {
            required: false,
        },
        showExtendedValuation: {
            type: Boolean,
            required: false,
            default: true,
        }
    },

    beforeCreate() {
        if (!this.$store.hasModule('ValuationTool')) {
            this.$store.registerModule('ValuationTool', require('./store/modules/valuation-tool').default);
        }
        if (!this.$store.hasModule('ValuationExtended')) {
            this.$store.registerModule('ValuationExtended', require('./store/modules/valuation-extended').default);
        }
        if (!this.$store.hasModule('Auth')) {
            this.$store.registerModule('Auth', require('../core/modules/Auth/auth').default);
        }
        if (!this.$store.hasModule('CustomerData')) {
            this.$store.registerModule('CustomerData', require('../used-vue/store/modules/customer-data').default);
        }
        if (!this.$store.hasModule('Dealers')) {
            this.$store.registerModule('Dealers', require('../used-vue/store/modules/dealers').default);
        }
    },

    created() {
        if (this.useSpecificDealer) {
            this.$store.dispatch('ValuationTool/useSpecificDealer', this.useSpecificDealer);
        }
        if (this.usedVehicleId) {
            this.$store.commit('ValuationTool/setUsedVehicleID', this.usedVehicleId);
        }
        if (this.newVehicleId) {
            this.$store.commit('ValuationTool/setNewVehicleID', this.newVehicleId);
        }
        if (this.newModelId) {
            this.$store.commit('ValuationTool/setNewModelID', this.newModelId);
        }
        try {
            this.$store.dispatch('ValuationExtended/fetchValuation');
        } catch (error) {
            console.error('Failed to fetch valuation:', error);
        }
    },

    computed: {
        ...mapState("ValuationTool", ["step", 'goToWidgetPosition', 'loadingValuationData']),
        ...mapGetters('Auth', ['loginModal']),
    },

    watch: {
        goToWidgetPosition(val) {
            if (val === true) {
                const targetElement = document.getElementById('valuation-start');
                if (targetElement) {
                    targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            }
        },
    },
};
</script>

<style lang="scss">
    @import "../../sass/redesign/valuation-widget/valuation";
</style>


// WEBPACK FOOTER //
// resources/assets/js/valuation-tool/ValuationTool.vue